import React from 'react';
import { BusinessTypes } from './helpers';
import {
	FormControl,
	FormHelperText,
	InputLabel,
	MenuItem,
	Select,
	TextFieldProps,
} from '@mui/material';
import useErrorScrollContext from '../../../hooks/useErrorScrollContext';
import { MuiCheckboxProps } from '../../../mui/MuiCheckbox';

export type BusinessStructureProps = {
	businessType?: BusinessTypes;
	setBusinessType: ( businessType: BusinessTypes ) => void;
	businessTypeValidation?: string;
	onBlur?: TextFieldProps['onBlur'] & MuiCheckboxProps['onBlur'];
};

export const BusinessStructure: React.FC<BusinessStructureProps> = ( {
	businessType,
	setBusinessType,
	businessTypeValidation,
	onBlur,
} ) => {
	const ref = useErrorScrollContext( !!businessTypeValidation );

	return (
		<FormControl fullWidth error={ !!businessTypeValidation } variant='standard'>
			<InputLabel htmlFor={ 'businessType' }>Business structure</InputLabel>
			<Select<BusinessTypes>
				ref={ ref }
				id='businessType'
				label='Business structure'
				value={ businessType || '' }
				onChange={ ( e ) => setBusinessType( e.target.value as BusinessTypes ) }
				onBlur={ onBlur }
				inputProps={ {
					'data-cy': 'businessType',
				} }
			>
				{ Object.entries( BusinessTypes ).map( ( [ value, label ] ) => (
					<MenuItem key={ value } value={ value }>
						{ label }
					</MenuItem>
				) ) }
			</Select>
			{ businessTypeValidation ? (
				<FormHelperText>{ businessTypeValidation }</FormHelperText>
			) : null }
		</FormControl>
	);
};
